module.exports = __webpack_public_path__ + "static/media/Funk.92af7b18.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/Window/Funk.mp3
// module id = 48
// module chunks = 0